import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useCallback } from "react";
import { LOCALE_PREFIXES } from "@/i18n";

/**
 * Locale-aware navigate wrapper.
 * Automatically prepends the current locale prefix to absolute paths.
 */
export function useLocaleNavigate() {
  const navigate = useNavigate();
  const params = useParams<{ locale: string }>();
  const location = useLocation();

  return useCallback(
    (to: string | number, options?: { replace?: boolean; state?: any }) => {
      if (typeof to === "number") {
        navigate(to);
        return;
      }

      // Determine current prefix
      let prefix = params.locale;
      if (!prefix) {
        const segments = location.pathname.split("/").filter(Boolean);
        const isKnown = LOCALE_PREFIXES.some((p) => p.prefix === segments[0]);
        prefix = isKnown ? segments[0] : "de";
      }

      const localeTo = to.startsWith("/") ? `/${prefix}${to}` : to;
      navigate(localeTo, options);
    },
    [navigate, params.locale, location.pathname],
  );
}
